import { render, staticRenderFns } from "./UserActivation.vue?vue&type=template&id=ebf7cea8&scoped=true"
import script from "./UserActivation.vue?vue&type=script&lang=js"
export * from "./UserActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf7cea8",
  null
  
)

export default component.exports